module.exports = __webpack_public_path__ + "media/images/tasting-long2-dab17d4c7aebe6b3f26d5fe7dfcfbe43.jpg";